export default {"src":"/_next/static/media/military-id.b4e34641.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};